export class SearchableCommand {
    id: string;
    short_description: string;
    description: string;
    relevant_icon: string;

    constructor(id: string, short_description: string, description: string, relevant_icon: string) {
        this.id = id;
        this.short_description = short_description;
        this.description = description;
        this.relevant_icon = relevant_icon;
    }

    create_html(): string {
        return `<div id='${this.id}' style='display: none'>
            <button type='button' class='btn uibtn'>
                <img class='iconimg' src='${this.relevant_icon}'/>
            </button>
            ${this.short_description}
        </div>`;
    }

    matches(x: string) {
        return this.description.toLowerCase().includes(x.toLowerCase())
            || this.short_description.toLowerCase().includes(x.toLowerCase());
    }
}
